module.exports = __webpack_public_path__ + "static/img/a111.69c3185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a111.jpg
// module id = gAsg
// module chunks = 0